"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldOfStudyList = void 0;
exports.fieldOfStudyList = [
    {
        value: "01",
        label: "Arts/Humanities/Social Science",
    },
    {
        value: "02",
        label: "Arts, Fine/Visual/Performing",
    },
    {
        value: "03",
        label: "Business/Commerce",
    },
    {
        value: "04",
        label: "Computing/IT",
    },
    {
        value: "05",
        label: "ESL/FSL",
    },
    {
        value: "06",
        label: "Flight Training",
    },
    {
        value: "07",
        label: "Hospitality/Tourism",
    },
    {
        value: "08",
        label: "Law",
    },
    {
        value: "09",
        label: "Medicine",
    },
    {
        value: "10",
        label: "Science, Applied",
    },
    {
        value: "11",
        label: "Sciences, General",
    },
    {
        value: "12",
        label: "Sciences, Health",
    },
    {
        value: "13",
        label: "Trades/Vocational",
    },
    {
        value: "14",
        label: "Theology/Religious Studies",
    },
    {
        value: "15",
        label: "Other",
    },
    {
        value: "16",
        label: "Agric/Agric Ops/Rel Sciences",
    },
    {
        value: "17",
        label: "Architecture and Rel Services",
    },
    {
        value: "18",
        label: "Biological/Biomed Sciences",
    },
    {
        value: "19",
        label: "Business/Mgmt/Marketing",
    },
];
